var map = {
	"./de/client.json": [
		345,
		795
	],
	"./el/client.json": [
		6902,
		852
	],
	"./en/client.json": [
		1442,
		673
	],
	"./es-ES/client.json": [
		7321,
		460
	],
	"./fr/client.json": [
		7244,
		474
	],
	"./nl/client.json": [
		9260,
		279
	],
	"./pl/client.json": [
		5549,
		28
	],
	"./pt-BR/client.json": [
		7698,
		446
	],
	"./ru/client.json": [
		8492,
		566
	],
	"./sk/client.json": [
		1585,
		259
	],
	"./sv-SE/client.json": [
		1142,
		684
	],
	"./tr/client.json": [
		5309,
		885
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 2167;
module.exports = webpackAsyncContext;